import { deleteApi, get, post } from "../GenericServices";

const ExpenseRefundFolder = {
  getExpenseRefundFolders: (queryString) => {
    return get(
      `expense-refund-folder${queryString !== "" ? `?${queryString}&sort=periodEnd;desc` : "?sort=periodEnd;desc"}`
    );
  },
  getExpenseRefundFolder: (id) => {
    return get(`expense-refund-folder/${id}`);
  },
  setExpenseRefundFolder: (data) => {
    return post(`expense-refund-folder`, data);
  },
  deleteExpenseRefundFolder: (id) => {
    return deleteApi(`expense-refund-folder/${id}`);
  },
};

export default ExpenseRefundFolder;
